import {
  Directive,
  Input,
  ViewContainerRef,
  TemplateRef,
  OnInit
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';

/**
 * @example
 * ```html
 * <elemento *appIsAllowed="'permissionOrRole'"/>
 * <elemento *appIsAllowed="'permissionOrRole'; else templateRef"/>
 * <elemento *appIsAllowed="['permissionOrRole']"/>
 * <elemento *appIsPermissionAllowed="'permission'"/>
 * <elemento *appIsPermissionAllowed="'permission'; else templateRef"/>
 * <elemento *appIsPermissionAllowed="['permission']"/>
 * <elemento *appIsRoleAllowed="'role'"/>
 * <elemento *appIsRoleAllowed="'role'; else templateRef"/>
 * <elemento *appIsRoleAllowed="['role']"/>
 *
 * <!-- use o else caso queira exibir outro template no lugar quando não tiver a permissão -->
 * ```
 *
 * @description funciona como um *ngIf porém usa as permissoes e roles como base
 */
@Directive({
  selector: '[appIsAllowed], [appIsPermissionAllowed], [appIsRoleAllowed]'
})
export class IsAllowedDirective implements OnInit {
  private roles!: string[];

  private elseTemplateRef!: TemplateRef<any>;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private _sessionService: SessionService
  ) {}

  ngOnInit() {
    this.update();
  }

  @Input()
  set appIsAllowed(value: string[]) {
    this.roles = value;
    this.update();
  }

  @Input()
  set appIsRoleAllowed(value: string[]) {
    this.roles = value;
    this.update();
  }

  @Input('appIsAllowedElse')
  @Input('appIsPermissionAllowedElse')
  @Input('appIsRoleAllowedElse')
  set else(tr: TemplateRef<any>) {
    this.elseTemplateRef = tr;
    this.update();
  }

  private update() {
    this.viewContainer.clear();
    let allowed = false;

    const rolesFromSession = this._sessionService.getRolesFromSession();

    rolesFromSession.forEach((role) => {
      if (this.roles.includes(role)) {
        allowed = true;
      }
    });

    if (allowed) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.elseTemplateRef) {
      this.viewContainer.createEmbeddedView(this.elseTemplateRef);
    }
  }
}
